import script from "./AiCheckDialogFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./AiCheckDialogFooter.vue?vue&type=script&setup=true&lang=js"

import "./AiCheckDialogFooter.vue?vue&type=style&index=0&id=17829da9&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17829da9"]])

export default __exports__